const OrderList = () => import('./components/OrderList.vue')
const OrderDetail = () => import('./components/OrderDetail.vue')

export default [
    {
        path: 'edge-orders',
        redirect: 'edge-orders',
        name: 'edgeOrders',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        meta: {
            label: 'Orders',
            title: 'Orders',
            breadcrumb: (context) => ({
                text: 'Orders',
                to: { name: 'edgeOrderList', params: context.route.params }
            })
        },
        children: [
            {
                path: '',
                name: 'edgeOrderList',
                component: OrderList,
                meta: {
                    label: 'Orders',
                    title: 'Orders',
                    perms: ['event_wizard.see_orders']
                },
            },
            {
                path: ':orderId([0-9]+)',
                name: 'edgeOrderDetail',
                component: OrderDetail,
                meta: {
                    label: 'Order detail',
                    breadcrumb: (context) => {
                        const order = context.store.getters['edgeOrders/currentOrder']
                        return {
                            text: order ? `Order #${order.order_number}` : `Order #${context.route.params.orderId}`
                        }
                    },
                    perms: ['event_wizard.see_orders']
                },
            }
        ]
    },
]